@if (envName !== 'prod') {
    <img class="stempel" src="assets/images/stempel-{{envName}}.svg" alt="Stempel" />
}
<router-outlet />
@if (globalErrorHandlerService.recoveryDialog(); as recoveryDialog) {
  <div class="recovery-dialog-backdrop"></div>
  <section class="recovery-dialog" aria-modal="true" role="alertdialog" aria-labelledby="recovery-dialog-title">
    <h2 id="recovery-dialog-title">{{ 'globalErrors.recovery.title' | transloco }}</h2>
    <p>{{ 'globalErrors.recovery.message' | transloco }}</p>
    @if (recoveryDialog.reason === 'chunk-load') {
      <p>{{ 'globalErrors.recovery.chunkHint' | transloco }}</p>
    }
    <div class="recovery-dialog__actions">
      <button type="button" class="recovery-dialog__reload" (click)="reloadForRecovery()">
        {{ 'globalErrors.recovery.reload' | transloco }}
      </button>
      <button type="button" class="recovery-dialog__dismiss" (click)="dismissRecoveryDialog()">
        {{ 'globalErrors.recovery.dismiss' | transloco }}
      </button>
    </div>
  </section>
}
<div class="debug-tools" [class.debug-tools--active]="errorOverlayOpen">
  <button
    type="button"
    class="errors-button"
    [attr.aria-label]="'globalErrors.button' | transloco"
    [class.errors-button--has-errors]="globalErrorHandlerService.getErrorCount() > 0"
    (click)="toggleErrorOverlay()"
  >
    <span class="pi pi-exclamation-circle" aria-hidden="true"></span>
    <span>{{ 'globalErrors.button' | transloco }} ({{ globalErrorHandlerService.getErrorCount() }})</span>
  </button>
  <div class="version" [title]="version.hash + ' ' + version.date">{{ version.hash }} {{ version.date }}</div>
  <div class="browser-session-id" [title]="globalErrorHandlerService.browserSessionId ?? ''">
    Session: {{ globalErrorHandlerService.browserSessionId ?? '-' }}
  </div>
</div>

@if (errorOverlayOpen) {
  <div class="error-overlay-backdrop" (click)="closeErrorOverlay()"></div>
  <section class="error-overlay" aria-modal="true" role="dialog">
    <div class="error-overlay__header">
      <div>
        <h2>{{ 'globalErrors.title' | transloco }}</h2>
        <p>{{ 'globalErrors.subtitle' | transloco }}</p>
      </div>
      <button type="button" class="error-overlay__close" (click)="closeErrorOverlay()">x</button>
    </div>

    <div class="error-overlay__actions">
      <button type="button" class="error-overlay__action" (click)="clearErrors()">{{ 'globalErrors.clear' | transloco }}</button>
    </div>

    @if (globalErrorHandlerService.entries().length) {
      <div class="error-list">
        @for (entry of globalErrorHandlerService.entries(); track entry.id) {
          <article class="error-card">
            <div class="error-card__meta">
              <span>{{ entry.timestamp }}</span>
              <span>{{ entry.source }}</span>
              @if (entry.statusCode) {
                <span>HTTP {{ entry.statusCode }}</span>
              }
            </div>
            <h3>{{ entry.message }}</h3>
            @if (entry.requestUrl) {
              <p>{{ entry.requestUrl }}</p>
            }
            @if (entry.filename || entry.lineNumber || entry.columnNumber) {
              <p>{{ entry.filename }} {{ entry.lineNumber }}:{{ entry.columnNumber }}</p>
            }
            @if (entry.details) {
              <pre>{{ entry.details }}</pre>
            }
          </article>
        }
      </div>
    } @else {
      <div class="error-overlay__empty">{{ 'globalErrors.empty' | transloco }}</div>
    }
  </section>
}
